import { ApiRequest } from '../../api/request';
import { DataResponse } from '@fino/ng1-response/lib';
// import sepa from 'sepa';

export class CreditorsService extends ApiRequest {
  constructor($http, $q, $log, appConfig) {
    'ngInject';
    super({ $http, $q, $log, appConfig });
  }

  find(q, limit = 0) {
    if (this.runningRequest) {
      this.runningRequest.resolve();
    }
    this.runningRequest = this.$q.defer();

    return this.$http({
      method: 'GET',
      url: `${this.api}/aid/creditors`,
      params: { q, limit },
      timeout: this.runningRequest.promise,
      error: {
        silent: true,
      },
    }).then(DataResponse.transform('data'));
  }

  findByCreditorId(creditorId) {
    return this.$http({
      method: 'GET',
      url: `${this.api}/aid/creditors/${creditorId}`,
    }).then(DataResponse.transform('data'));
  }

  suggestCreditorId(cid, limit = 10) {
    if (this.runningRequest) {
      this.runningRequest.resolve();
    }
    this.runningRequest = this.$q.defer();

    return this.$http({
      method: 'GET',
      url: `${this.api}/aid/creditors`,
      params: { cid, limit },
      timeout: this.runningRequest.promise,
      error: {
        silent: true,
      },
    }).then(DataResponse.transform('data'));
  }

  autocorrectCreditorId(creditorId) {
    // check if we can autofix creditorId:
    // The German Creditor Identifier is 18 characters long, where characters :

    // 1 – 2: ISO Country Code (DE – Germany)
    // We check if the D is maybe wrongly OCR'd to 'O' or '0'
    const fixDe = /^[O0]e/i.test(creditorId);
    if (fixDe) {
      creditorId = `DE${creditorId.substr(2)}`;
    }

    // 3 – 4: Fix wrongly OCR'd digits
    const fixDigits = !/(DE)(\d){2}/.test(creditorId);
    if (fixDigits) {
      creditorId = this.fixCharToDigit(creditorId, 2, 2);
    }

    // 5 – 7: Creditor Business Code – you (Creditor) choose this. The default is ZZZ
    // We check if the Creditor Business Code (position 5-7) is
    // the default 'ZZZ' but wrongly OCR'd and one or more 'Z's
    // are interpreted as 2. So we fix that in case of
    // there are at least one 'Z' and one 2.
    const fixCreditor =
      'ZZ2 Z2Z 2ZZ Z22 2Z2 22Z 222'
        .split(' ')
        .indexOf(creditorId.substr(4, 3)) > -1;
    if (fixCreditor) {
      creditorId = `${creditorId.substr(0, 4)}ZZZ${creditorId.substr(7)}`;
    }

    // 8 – 18: Creditor National Identifier – a consecutive number that will be assigned to you, with leading zeros
    const fixNationalIdentifier = !/^((DE)(\d){2}(\w{3})[a-z]+)/i.test(
      creditorId,
    );
    if (fixNationalIdentifier) {
      creditorId = this.fixCharToDigit(creditorId, 7);
    }

    // let isValid = sepa.validateCreditorID(creditorId);

    return creditorId;
  }

  // We check if any:
  // - '0' is wrongly OCR'd to 'O'
  // - '1' is wrongly OCR'd to 'I|l|t'
  // - '2' is wrongly OCR'd to 'Z'
  // - '5' is wrongly OCR'd to 'S'
  // - '9' is wrongly OCR'd to 'g'
  fixCharToDigit(value, start, len) {
    let fixed = value.substr(start, len);
    fixed = fixed.replace(/o/gi, 0);
    fixed = fixed.replace(/I|l|t/gi, 1);
    fixed = fixed.replace(/z/gi, 2);
    fixed = fixed.replace(/s/gi, 5);
    fixed = fixed.replace(/g/gi, 9);

    const before = value.substr(0, start);
    const after = len ? value.substr(start + len) : '';

    return `${before}${fixed}${after}`;
  }
}
